var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appFooter"},[_vm._v(" Yamada-ha Shito-ryu Shukokai Karatedo Union India | "+_vm._s(_vm.year)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }